// extracted by mini-css-extract-plugin
module.exports = {"coachingPage":"main-buy-coaching_coachingPage_2bzwA","productsTable":"main-buy-coaching_productsTable_3b4lF","tableBtn":"main-buy-coaching_tableBtn_b1IW0"};